import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label"];
import { Flex } from '../../../components/Flex/Flex';
import { IconButton } from '../IconButton';
import { LeftIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviousButton = _ref => {
  let {
      'aria-label': ariaLabel
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
    "aria-label": ariaLabel,
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      as: "span",
      children: /*#__PURE__*/_jsx(LeftIcon, {})
    })
  }));
};